import axios from "@/axios";

const endpoint = "/role";

const Role = {
  put: async (id) => {
    return axios.put(`${endpoint}/${id}`)
    .then((role) => role)
    .catch((error) => {
        console.log(error)
        return error
    })
  },
};

export default Role;
